import React, { useContext, useMemo, useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  TableRow,
  TableCell,
  Checkbox,
  Chip,
  Typography,
  Stack,
  Avatar,
  Button,
  Box,
} from '@mui/material';
import OrderTableHead from './OrderTableHead';
import { CommonContext, GaintOFDOrdersContext } from '../../context';
import { delivery_type_id } from '../../utils/config';
import moment from 'moment/moment';
import { LinkOutlined, LocalShipping, Person, RecordVoiceOverOutlined, Download as DownloadIcon } from '@mui/icons-material';
import TableSkeleton from '../common/TableSkeleton';
import { useNavigate } from 'react-router-dom';

import { FileCopy as FileCopyIcon } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';


export default function OrderTable() {
  const navigate = useNavigate();
  const { firstLoading, allData, allOrders, selected, setSelected, page, setPage, rowsPerPage, setRowsPerPage, viewDetail, onTracking, onManifestGen, onCalling, onRecording, activeTab } = useContext(GaintOFDOrdersContext);
  const { getOrderStatus, getOrderStatusColor, user } = useContext(CommonContext);

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('created_at');
  const [copied, setCopied] = useState(false);

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleSelect = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((item) => item !== id);
    }

    setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = allOrders.map((order) => order.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // const sortedRows = orders.slice().sort(getComparator(order, orderBy));

  const sortedRows = useMemo(() => {
    return [...allOrders].sort((a, b) => {
      if (order === 'asc') {
        return a[orderBy] > b[orderBy] ? 1 : -1;
      } else {
        return a[orderBy] < b[orderBy] ? 1 : -1;
      }
    });
  }, [allOrders, orderBy, order]);

  const renderManifestCell = ({ row, onManifestGen }) => {
    return (
      <Button
        variant="outlined"
        size="small"
        startIcon={<DownloadIcon />}
        onClick={() => onManifestGen(row.id)}
        sx={{ textWrap: 'nowrap' }}
      >
        Download
      </Button>
    );
  };


  const handleCopy = (value) => {
    navigator.clipboard.writeText(value); // Copying text to clipboard
    setCopied(true); // Setting copied state to true
    setTimeout(() => setCopied(false), 1000); // Resetting copied state after 1.5 seconds
  };
  return (
    <div className='table-component'>
      {firstLoading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="body2">
            <strong>{selected.length}</strong> Orders Selected
          </Typography>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 150, 200, 250]}
            component="div"
            count={allData?.TotalRows || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      ) : null}
      <TableContainer>
        <Table size="small">
          <OrderTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            selected={selected}
            onSelectAllClick={handleSelectAllClick}
            rowCount={sortedRows.length}
          />
          <TableBody>
            {!firstLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ p: 0 }}>
                  <TableSkeleton rows={10} columns={8} />
                </TableCell>
              </TableRow>
            ) : sortedRows.length > 0 ?
              sortedRows.map((row) => {
                const isItemSelected = isSelected(row.id);
                return (
                  <TableRow hover key={row.id} selected={isItemSelected}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onChange={() => handleSelect(row.id)}
                        className="custom-checkbox"
                      />
                    </TableCell>
                    {user?.user_type !== "Merchant" && (
                      <TableCell align="left">{row?.merchant?.company_name}</TableCell>
                    )}

                    <TableCell>
                      <Typography className='link-text' onClick={() => viewDetail(row.id)}>
                        {row.order_no || 'NA'} <LinkOutlined sx={{ fontSize: '0.75rem', verticalAlign: 'middle', marginLeft: '3px' }} />
                      </Typography>
                    </TableCell>
                    {activeTab === 2 && (
                      <TableCell>
                        {row?.invoice_no || 'NA'}
                      </TableCell>
                    )}
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar sx={{ width: 32, height: 32, bgcolor: '#004d40' }}>
                          <Person sx={{ fontSize: 18, color: '#fff' }} />
                        </Avatar>
                        <Typography className='custome-typography'>
                          {row.customer_name}<br />
                          <small>{row.customer_city}<br />{row.customer_state}</small>
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar sx={{ width: 32, height: 32, bgcolor: '#004d40' }}>
                          <LocalShipping sx={{ fontSize: 18, color: '#fff' }} />
                        </Avatar>
                        <Stack spacing={0.3}>
                          <Typography className='copy-section'>
                            <Chip
                              label={row?.awb_no || 'N/A'}
                              size="small"
                              className="awb-chip cutom-table-chip"
                            />
                            <Tooltip title={copied ? "Copied" : "Copy AWB Number"} placement="top" arrow>
                              <IconButton onClick={() => handleCopy(row.awb_no)}>
                                <FileCopyIcon />
                              </IconButton>
                            </Tooltip>
                          </Typography>

                          <Typography sx={{ fontSize: '0.8rem' }}>
                            <strong>{row?.courier?.brand_name}</strong>
                          </Typography>
                        </Stack>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <div>
                        <Chip
                          variant="outlined"
                          label={getOrderStatus(row.order_status_id)}
                          color={getOrderStatusColor(row.order_status_id)}
                          size="small"
                          className="cutom-table-chip"
                          onClick={() => onTracking(row.id)}
                        />
                      </div>
                      {row.order_status_id === 21 && (
                        <div>
                          <Chip
                            label="Re-ship"
                            color="info"
                            size="small"
                            className="cutom-table-chip"
                            sx={{ mt: 1, cursor: 'pointer' }}
                            onClick={() => navigate('/orders/create-b2c', { state: row })}
                          />
                        </div>
                      )}
                    </TableCell>

                    <TableCell>
                      {row?.merchant_warehouse?.contact_person}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={delivery_type_id[row.delivery_type_id]}
                        color={delivery_type_id[row.delivery_type_id] === 'COD' ? 'info' : 'success'}
                        className="cutom-table-chip"
                        size="small" />
                      <br />
                      <small>{row?.delivery_type_id === 1 ? row?.product_cod_value : row?.product_invoice_value}</small>
                    </TableCell>
                    <TableCell>
                      <Typography className='custome-typography' sx={{ whiteSpace: 'nowrap' }}>
                        {row.created_at ? moment(row.created_at).format('DD-MM-YYYY') : 'NA'}<br />
                        <small>{row?.user?.name}</small>
                      </Typography>
                    </TableCell>
                    {activeTab !== 21 && (
                      <TableCell>
                        {renderManifestCell({ row, onManifestGen })}
                        {row?.is_ivr === 1 && (
                          <Chip
                            variant="outlined"
                            label={'Recording'}
                            color={'secondary'}
                            size="small"
                            className="cutom-table-chip"
                            icon={<RecordVoiceOverOutlined />}
                            sx={{ my: 1, cursor: 'pointer' }}
                            onClick={() => onRecording(row)}
                          />
                        )}


                      </TableCell>
                    )}

                  </TableRow>
                );
              }) : (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No orders found
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
